import React from 'react';

import {
  
  PSVEindhoven,
  Feyenoord,
  AjaxAmsterdam,
  FCTwente,
  AZAlkmaar,
  DWS,
  SpartaRotterdam,
  DOS,
 
 } from "../clubs";

const Eredivisie = () => {
  return (
    <div>

      <h1>Dates of the last league titles for each club that has won Eredivisie.</h1>

      <PSVEindhoven />
      <Feyenoord />
      <AjaxAmsterdam />
      <FCTwente />
      <AZAlkmaar />
      <DWS />
      <SpartaRotterdam />
      <DOS />

    </div>
  )
}

export default Eredivisie